/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Type_DeliveredInputs */

const vi_notif_type_delivered = /** @type {(inputs: Notif_Type_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã giao thành công`)
};

/**

* @param {Notif_Type_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_type_delivered = /** @type {((inputs?: Notif_Type_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Type_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_type_delivered(inputs)
});